import { registerVueComponentAndAngularBindings, declareVueComponent } from '/vodalys/vvuejs'

import VrunFormResultPage from './VrunFormResultPage.vue'
import VrunFormResultNoData from './VrunFormResultNoData.vue'
import VrunFormResultDate from './VrunFormResultDate.vue'

registerVueComponentAndAngularBindings('vrun_form:result_page', 'vrunFormResultPage', VrunFormResultPage)

declareVueComponent('vrunFormResultNoData', VrunFormResultNoData);
declareVueComponent('vrunFormResultDate', VrunFormResultDate)
